export const DASHBOARD_BANNER_COMPLETED_KEY = 'dashboard_banner_completed';
